<div class="component-block">
  <h2>Security Settings</h2>
  <label class="checkbox-input-large">
    <input type="checkbox" [(ngModel)]="enable2FA" (change)="toggle2FA()" />
    Enable Two-Factor Authentication
  </label>
</div>